import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { Validation } from './enums/validation.enum';

export const amountEqualValidator = (currentAmount: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (currentAmount === control.value) {
      return {
        [Validation.EqualAmount]: true,
      };
    }

    return null;
  };
};
